import "jquery-validation"; //nmp
require('./core/formbuilder/form');

